
const PinDebit = () => {
  return(
    <div>Pin Debit</div>
  )
}

export default PinDebit